import React, { useEffect, useState } from "react";
import './ViewProjectAnchorTraining.css';
import {Card, Table, Row, Col} from 'react-bootstrap';
import AddAnchorTraining from "./AddAnchorTraining/AddAnchorTraining";
import { useNavigate, useParams } from "react-router-dom";
import ViewAnchorTraining from "./ViewAnchorTraining";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { MdAddCircle } from "react-icons/md";
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import ApiResponseHandler from "../../../../../../MasonyFixingsAPIs/ApiResponseHandler";

export default function ViewProjectAnchorTraining(){

    const params = useParams();
    const navigate = useNavigate();

    const ColumnHeaders = ['Delviered By', 'Date', 'Note', 'Actions']

    const [loading, setLoading] = useState(true);
    const [showTable, setShowTable] = useState(false);
    const [anchorTrainingData, setAnchorTrainingData] = useState([]);
    const [showAddNew, setShowAddNew] = useState(false);

    const getAnchorTraining = (projectID) => {
        ProjectAPIs.GetProjectAnchorTraining(projectID)
        .then((response) => {
            if(response.status === 200){
                setAnchorTrainingData(response.data);
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err)
            ApiResponseHandler(err.response, navigate)
        })
    }

    const handleAddNew = () => {
        setShowAddNew(false);
        getAnchorTraining(params.ProjectID);
    }


    const thData = () => {

        return ColumnHeaders.map((header, index) => {
            return(
                <th key={index}>{header}</th>
            )
        })
    }


    useEffect(() => {
        getAnchorTraining(params.ProjectID)
    }, [params.ProjectID])

    if(loading){
        return(<div>Loading...</div>)
    }
    return(         
        <div className="project-section">
            <div className="project-section-header">
                <h5 className="section-title">Project Anchor Trainings</h5>
            </div>
        
            <AddAnchorTraining projectID={params.ProjectID} handleAddNew={handleAddNew} />

            <div className="mt-2">
                {anchorTrainingData.map((item) => (
                    <ViewAnchorTraining key={item.id} anchorTraining={item} getAnchorTraining={getAnchorTraining} />
                
                ))}
            </div>
    </div>

    )
        
    
}